<div class="d-inline-block" ngbDropdown container="body" placement="top-left" #myDrop="ngbDropdown" (openChange)="onTimeRangeOpening($event)">
    <button class="btn btn-sm btn-outline-primary me-2" id="rangeDatePicker" ngbDropdownToggle>
        <i class="far fa-calendar-alt"></i> <span class="ms-2 me-2 text-body">{{ label }}</span>
    </button>

    <div [formGroup]="form" ngbDropdownMenu class="rounded-0 border shadow p-2" aria-labelledby="rangeDatePicker">
        <div class="d-flex mb-2 justify-content-between">
            <div class="pe-1 flex-fill">
                <input formControlName="startTime" class="form-control form-control-sm rounded-0 w-100" type="text" placeholder="Start" />
                @if (form.errors?.invalidStartTime) {
                    <div class="form-text text-danger"><i class="fas fa-exclamation-circle"></i> {{ form.errors['invalidStartTime'] }}</div>
                }
            </div>
            <div class="ps-1 flex-fill">
                <input formControlName="endTime" class="form-control form-control-sm rounded-0 w-100" type="text" placeholder="End" />
                @if (form.errors) {
                    <div class="form-text text-danger">
                        @if (form.errors?.invalidEndTime) {
                            <div><i class="fas fa-exclamation-circle"></i> {{ form.errors['invalidEndTime'] }}</div>
                        }
                        @if (form.errors?.isSameOrBefore) {
                            <div><i class="fas fa-exclamation-circle"></i> {{ form.errors['isSameOrBefore'] }}</div>
                        }
                    </div>
                }
            </div>
        </div>

        @if (form.errors?.timeSpanExceeded) {
            <div class="form-text text-danger mb-1"><i class="fas fa-exclamation-circle"></i> {{ form.errors['timeSpanExceeded'] }}</div>
        }

        <hr class="mb-2" />

        <ngb-datepicker #datepicker navigation="arrows" #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="datePickerTemplate" outsideDays="hidden"> </ngb-datepicker>

        <div class="text-end">
            <hr class="mb-2" />
            <button type="button" class="btn btn-primary" (click)="save(); myDrop.close()" [disabled]="!form.valid || !form.dirty">{{ 'actions.save' | translation | async }}</button>
            <button type="button" class="btn btn-secondary ms-2" (click)="myDrop.close()">{{ 'actions.cancel' | translation | async }}</button>
        </div>
    </div>
</div>

<ng-template #datePickerTemplate let-date let-focused="focused">
    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInsideTimeSpan(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
        {{ date.day }}
    </span>
</ng-template>
